export default function createServiceProfile({ next, store }) {
  const status = store.getters['auth/getRole']
  if (status === 'Partner') {
    return next()
  }
  return next({ name: 'misc-not-authorized' })
}
